/* Copyright (c) 2026 Xperi. All Rights Reserved. */

export { default as guideReducer } from "./guideSlice";
export {
  GUIDE_ERROR_CODE,
  GuideErrorMapper,
  getGuideErrorTitle,
  getGuideErrorDescription
} from "./guideErrorMapper";
export {
  GUIDE_SCREEN_ID,
  GUIDE_SCREEN_NAME,
  GUIDE_LIST_NAME,
  GUIDE_PREVIEW_DEBOUNCE_DELAY_MS,
  GuideAnalyticsLogger,
  logGuideFutureProgramSelection,
  captureGuideEntryScreen,
  logGuideViewedScreen,
  loadGuideChannels,
  loadGuideRows,
  loadGuideWindow,
  settleGuideWindow,
  handleGuideRowsFailure,
  startGuidePlayback,
  toggleFavoriteChannel,
  handleGuideKeyOk,
  setGuideLoading,
  setGuideNavMode,
  setGuideLoadingTimedOut,
  setGuideError,
  setGuideRowsFailed,
  applyGuideRowsFailure,
  setCurrentWindowStartTime,
  setIsPastGuide,
  resetGuideRows,
  resetGuideState,
  resetGuideToLivePosition,
  resetGuideToLivePositionIfFromHome,
  setGuideHighlightVerticalPosition,
  setGuideHighlightHorizontalPosition,
  setGuideGridFocus,
  setGuideSidebarFocus,
  navigateGuideUp,
  navigateGuideDown,
  setIsSidebarFocused,
  navigateGuideLeft,
  navigateGuideRight,
  setChannelScrollOffset,
  positionGuideHighlightToLastTunedChannel,
  setGuideRowsDirect,
  mergeGuideRows,
  setFutureWindowStartTime,
  setPastWindowStartTime,
  shiftTimeAxisForward,
  shiftTimeAxisBackward,
  advanceWindowForAutoRefresh,
  autoRefreshGuideWindow,
  refreshGuideOnResume,
  toggleGuideFilter,
  restoreGuideFilterSelection,
  restoreAndResolveGuideFilterSelection,
  setIsFilterSidebarExpanded,
  closeGuideFilterSidebar,
  cleanupFavoritePersistJobs,
  cleanupGuideFilterApplyJob,
  selectIsGuideLoading,
  selectGuideError,
  selectIsGuideRowsFailed,
  selectGuideChannels,
  selectCurrentWindowStartTime,
  selectGuideStartTime,
  selectGuideTimeBarLabel,
  selectIsPastGuide,
  selectIsGuideSidebarFocused,
  selectGuideSidebarFocusIndex,
  selectGuideHighlightVerticalPosition,
  selectGuideHighlightHorizontalPosition,
  selectEffectiveGuideHighlightVerticalPosition,
  selectEffectiveGuideHighlightHorizontalPosition,
  selectChannelScrollOffset,
  selectGuideSessionStartMs,
  selectFutureWindowStartTime,
  selectPastWindowStartTime,
  selectGuideTimeSlots,
  selectGuideVisibleRows,
  selectGuideWindowLoadGeneration,
  selectGuideLoadingTimedOut,
  selectGuideHasLoadingCells,
  selectVisibleChannels,
  selectFocusedGuideChannel,
  selectFocusedGuideCell,
  selectIsFocusedGuideCellPlaceholder,
  selectSelectedGuideFilterIds,
  selectCategoryFilterChannelIds,
  selectCategoryFilterResolutionStatus,
  selectIsGuideFilterSidebarExpanded,
  selectShouldShowGuideFilterEmptyState,
  selectIsGuideGridEmptyByFilter,
  fetchGuideNpvrAllowRecording,
  selectIsNpvrRecordingAllowed,
  fetchGuideOfferPreview,
  clearGuidePreview,
  selectGuidePreviewData,
  selectIsGuidePreviewLoading,
  selectIsFocusedGuideChannelRecordable,
  selectFocusedGuideChannelLogoUrl,
  selectFocusedGuideChannelHasSocu,
  selectIsFocusedGuideChannelJump,
  selectIsFocusedProgramSocuAvailable,
  selectFocusedGuideChannelIsTivoPlus,
  selectFocusedGuideChannelAppIconUrl,
  handleGuideDigitKey,
  flushGuideJumpEntry,
  resetGuideJumpEntry,
  clearGuideJumpTimers,
  clearGuideSettleTimer,
  selectGuideJumpDigits,
  selectIsGuideJumpVisible,
  selectIsGuideJumpError,
  loadGuideFilters,
  selectGuideFilterItems,
  selectHasFavoriteChannels,
  selectIsFavoritesFilterActive
} from "./guideSlice";
export { GuideTimeWindow } from "./guide.types";
export { GuideNavMode } from "./guide.types";
export { getGuideFavoritesFallbackFilter } from "./guideFilters";
export {
  createGuideCellViewPlaceholder,
  EMPTY_GUIDE_ROWS
} from "./guideNavigation";
export type {
  GuideCellUiProps,
  GuideCellView,
  GuideJumpToChannelState,
  GuideRowsState,
  GuideState,
  GuideVisibleChannelRow,
  GuideVisibleRowView,
  LoadGuideRowsPayload,
  TGuideFilterItem
} from "./guide.types";
